import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Message } from 'primereact/message';

/**
 * QuickBooks OAuth Callback Screen
 * This is where QuickBooks redirects after OAuth authorization
 */
export const QuickBooksCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success');
  const error = searchParams.get('error');
  const clientId = searchParams.get('client_id');

  useEffect(() => {
    // Notify parent window (the main app) that OAuth completed
    if (window.opener) {
      window.opener.postMessage(
        {
          type: 'qb_oauth_complete',
          success: success === 'true',
          error,
          clientId,
        },
        window.location.origin
      );

      // Close this window after a short delay
      setTimeout(() => {
        window.close();
      }, 2000);
    }
  }, [success, error, clientId]);

  return (
    <div className="quickbooks-callback-container">
      <Card>
        {success === 'true' ? (
          <div className="callback-content-center">
            <Message severity="success" text="QuickBooks linked successfully!" />
            <p className="callback-message">
              This window will close automatically...
            </p>
          </div>
        ) : error ? (
          <div className="callback-content-center">
            <Message severity="error" text={`Error: ${error}`} />
            <p className="callback-message">
              Please close this window and try again.
            </p>
          </div>
        ) : (
          <div className="callback-content-center">
            <ProgressSpinner />
            <p className="callback-message-primary">Processing QuickBooks authorization...</p>
          </div>
        )}
      </Card>
    </div>
  );
};

export default QuickBooksCallback;
